import BiPaiSeatCards from "./bipai_seat_cards";
import TransformHolder from "./transformHolder";
import Utility from "../../../../utility/utility";
import PromiseUtility from "../../../../utility/promiseUtility";

const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu("custom/bipai/BiPaiSeatDispatchedCards")
export default class BiPaiSeatDispatchedCards extends BiPaiSeatCards{

    @property(cc.Float)    
    maxRadius: number = 0

    @property([cc.Vec2])
    angelRangeList: cc.Vec2[] = []

    @property(TransformHolder)
    originalParentTranHolder: TransformHolder = null

    @property(TransformHolder)
    recycleTranHolder: TransformHolder = null

    playDispatchAnim(codeList: number[], duration: number, delay: number, fromWorldPos?: cc.Vec2, onFinish?: Function){
        let self = this
        this.showPokers(true, codeList)
        let targetTranData = this.originalParentTranHolder.transformDataList[0]
        let node = this.nodePokersParent
        if(!fromWorldPos){
            fromWorldPos = this.fromTransformHolder.transformDataList[0].worldPos
        }
        node.position = node.parent.convertToNodeSpaceAR(fromWorldPos)
        self.playNodeAnim(node, self.randomTargetPos(node, targetTranData.worldPos, self.maxRadius), targetTranData.scale, node.angle, duration, delay, onFinish, cc.easeExponentialOut())
    }

    playRecycleAnim(duration: number, interval: number, delay: number, onFinish?: Function){
        let self = this
        let targetTranData = self.recycleTranHolder.transformDataList[0]
        let pokers = self.pokers
        self.pokers = []
        let do_funs = []
        for (let index = 0; index < pokers.length; index++) {
            const poker = pokers[index];
            let targetPos = poker.node.parent.convertToNodeSpaceAR(targetTranData.worldPos)            
            let tmp_fun = function(cb){
                self.playNodeAnim(poker.node, targetPos, targetTranData.scale, targetTranData.angle - poker.node.parent.angle, duration, delay + index * interval, function(){
                    self.playFadeAnim(poker.node, poker.node.opacity, 0, duration * 0.46, 0, function(){
                        poker.node.opacity = 255
                        poker.hide()
                        cb && cb()
                    })
                }, cc.easeQuinticActionOut())
            }
            do_funs.push(tmp_fun) 
        }
        if(do_funs.length == 0){
            onFinish && onFinish()
            return
        }
        PromiseUtility.all(do_funs).then(function(){
            self.removeAllPokers(pokers)  
            onFinish && onFinish()
        })
    }
        

    showPokers(show: boolean, codeList?: number[], params?: any){
        this.unscheduleAllCallbacks()
        this.removeAllPokers()        
        if(show){
            let pokerList = this.genPokerList(codeList, false)
            for (let index = 0; index < pokerList.length; index++) {
                let poker = pokerList[index]    
                poker.node.opacity = 255
                poker.show()
                poker.showFace(poker.code != 0)
                poker.showBack(poker.code == 0)
                if(params){
                    if(params.hidePoker){
                        poker.hide()
                    }
                    if(params.showBack){
                        poker.showBack(true)
                        poker.showFace(false)
                    }
                }                                         
            }
            let tranData = this.originalParentTranHolder.transformDataList[0]
            let node = this.nodePokersParent
            node.position = this.randomTargetPos(node, tranData.worldPos, this.maxRadius)
            node.scale = tranData.scale
            let angelRange
            if(codeList.length == 0){
                angelRange = cc.Vec2.ZERO
            }else{
                angelRange = this.angelRangeList[codeList.length - 1]
            }
            angelRange = angelRange || cc.Vec2.ZERO
            node.angle = Utility.random(angelRange.x, angelRange.y)
            let centerLocalPos = this.formatPokersLayout(pokerList)

            let worldPos = this.nodePokersParent.convertToWorldSpaceAR(centerLocalPos)
            return worldPos
        }
        return cc.Vec2.ZERO
    }

    protected randomTargetPos(node: cc.Node, targetWorldPos: cc.Vec2, maxRadius: number): cc.Vec2{
        let offset_src = Utility.randomInsideRadius(maxRadius);
        let localPos = node.parent.convertToNodeSpaceAR(targetWorldPos)
        return new cc.Vec2(localPos.x + offset_src.x, localPos.y + offset_src.y); 
    }
}
